import Actions from '.';
import { get, post, put, deleteCall } from '../../../utils/api';
import { API_ERROR_MESSAGE } from '../../../constants';

const getBroadCast = () => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`broadcasts/list`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                list: data.response.broadcasts || [],
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                list: [],
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loadingData: false,
            error: e.message || API_ERROR_MESSAGE,
            list: []
        }));
    }
});

const addBroadCast = values => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const { broadCastImage, broadCastDesc, offers, products } = values
        const body = new FormData();
        body.append('description', broadCastDesc);
        body.append('offerId',offers.length?offers[0]:"");
        body.append('productId',products.length?products[0]:"");
        body.append('file', broadCastImage);
        console.log(body);

        const data = await post(`broadcasts`, body, { contentType: 'multipart/form-data' });
        if (data.statusCode === 201) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message,
                showModal: false,
            }));
            dispatch(getBroadCast());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

const publishBroadCast = id => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await post(`broadcasts/publish/${id}`,);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message,
                showModal: false,
            }));
            dispatch(getBroadCast());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

const editBroadCast = values => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const { bannerImage, title, screen, categoryId, subcategoryId, id } = values
        const body = new FormData();
        body.append('title', title);
        body.append('screen', screen);
        body.append('subcategoryId', subcategoryId);
        body.append('categoryId', categoryId);
        if (typeof bannerImage !== 'string') body.append('bannerImage', bannerImage);
        const data = await put(`broadcasts/${id}`, body, { contentType: 'multipart/form-data' });
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message,
                showModal: false,
            }));
            dispatch(getBroadCast());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

const deleteOrders = id => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await deleteCall(`broadcasts/${id}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
            }));
            dispatch(getBroadCast());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

export default {
    getBroadCast,
    addBroadCast,
    editBroadCast,
    publishBroadCast,
    deleteOrders
}